import { UserAddOutlined } from '@ant-design/icons'
import { FloatButton, Tabs, TabsProps } from 'antd'
import clsx from 'clsx'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { ActiveUsersTable } from './components/active-users-table/active-users-table'
import { InvitedUsersTable } from './components/invited-users-table/invited-users-table'
import { RolesModal } from './components/roles-modal/roles-modal'
import { UserModal } from './components/user-modal/user-modal'
import styles from './styles/user.page.module.scss'
import { UserInviteData } from './types/users.types'
import { useModal } from '../../../common/hooks/formik/modal.hook'
import { ModalBottom } from '../../../common/ui/modal/modal-bottom'
import { useProjectStore } from '../../../entities/projects/stores/project.store'
import { useGetRoles } from '../../../entities/roles/hooks/role.hooks'
import { useInviteUser } from '../../../entities/user/hooks/user.hooks'
import { User } from '../../../entities/user/types/user.types'
import { PageHeader } from '../../shared/components/page-header'

export const UsersPage = () => {
  const { t } = useTranslation()
  const [selectedUser, setSelectedUser] = useState<User | null>(null)
  const [userRoles, setUserRoles] = useState([])

  const userModal = useModal(false)
  const rolesModal = useModal(false)
  const userModalFormRef = useRef<{ submit: () => void; clear: () => void } | null>(null)

  const { data: roles } = useGetRoles()
  const projects = useProjectStore((store) => store.projects)
  const { mutateAsync: inviteUser } = useInviteUser()

  const handleSubmitForm = async (values: any) => {
    try {
      if (!selectedUser) {
        const newUser: UserInviteData = {
          ...values,
        }
        await inviteUser(newUser)
        toast.success(t('usersPage.addNewUser.inviteUserSuccess'))
        userModalFormRef.current?.clear()
      } else {
        const updatedUser: User = {
          ...selectedUser,
          ...values,
        }
      }
    } catch (e) {
      toast.error(t('usersPage.addNewUser.errors.cannotInviteUser'))
    }
    userModal.close()
    setSelectedUser(null)
  }

  const tabs: TabsProps['items'] = [
    {
      key: '1',
      label: t('usersPage.activeUsers'),
      children: <ActiveUsersTable />,
    },
    {
      key: '2',
      label: t('usersPage.invitedUsers'),
      children: <InvitedUsersTable />,
    },
  ]

  return (
    <div className={clsx(styles.usersPage)}>
      <PageHeader
        description={t('usersPage.description')}
        header={t('usersPage.header')}
      />
      <Tabs
        defaultActiveKey="1"
        items={tabs}
      />
      <FloatButton
        icon={<UserAddOutlined />}
        onClick={() => userModal.open()}
        type="primary"
      />
      <ModalBottom
        onCancel={userModal.close}
        onOk={() => userModalFormRef.current?.submit()}
        open={userModal.opened}
        title={t('usersPage.addNewUser.title')}
      >
        <UserModal
          ref={userModalFormRef}
          initialValues={null}
          onSubmit={handleSubmitForm}
          projects={projects}
          roles={roles ?? []}
        />
      </ModalBottom>
      <ModalBottom
        onCancel={rolesModal.close}
        onOk={rolesModal.close}
        open={rolesModal.opened}
        title="Roles"
      >
        <RolesModal
          initialRoles={userRoles}
          onDelete={() => {}}
          roles={userRoles}
          setIsRoleModalOpen={() => {}}
          setname={() => {}}
        />
      </ModalBottom>
    </div>
  )
}
